import React, { useState, useEffect } from "react";
import { BoxAbi } from "./Contracts/Box";
import { saveAs } from "file-saver";
import { useAccount } from "wagmi";
import { Toaster, toast } from "react-hot-toast";
import axios from "axios";
import { useSigner } from "wagmi";
import { ethers } from "ethers";
import Profile from "./Profile";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import { getMagic, getMagic1 } from "./web3";
import { FiExternalLink } from "react-icons/fi";
import Loading from "./Loading";
import { useNavigate } from "react-router-dom";

const privateKey = process.env.REACT_APP_ADMIN_PRIVATEkEY;
const NODE_URL = process.env.REACT_APP_NODE_URL;

//cutom Signer
const customProvider = new ethers.providers.JsonRpcProvider(NODE_URL);
const customSigner = new ethers.Wallet(privateKey, customProvider);

const Files = () => {
  const navigate = useNavigate();

  const newAddress = localStorage.getItem("newaddress");
  const JWT = `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySW5mb3JtYXRpb24iOnsiaWQiOiI3MzVmZGI5My00NWVjLTRiOWQtODgxMi1mMDhhYWRkMjI3YWUiLCJlbWFpbCI6ImZhaGVlbWZlcm96MTExOUBnbWFpbC5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwicGluX3BvbGljeSI6eyJyZWdpb25zIjpbeyJpZCI6IkZSQTEiLCJkZXNpcmVkUmVwbGljYXRpb25Db3VudCI6MX0seyJpZCI6Ik5ZQzEiLCJkZXNpcmVkUmVwbGljYXRpb25Db3VudCI6MX1dLCJ2ZXJzaW9uIjoxfSwibWZhX2VuYWJsZWQiOmZhbHNlLCJzdGF0dXMiOiJBQ1RJVkUifSwiYXV0aGVudGljYXRpb25UeXBlIjoic2NvcGVkS2V5Iiwic2NvcGVkS2V5S2V5IjoiM2JkYzdhZjYxYTkxNDBjM2FhOTIiLCJzY29wZWRLZXlTZWNyZXQiOiI5NmU5MTM5ZTlhYTQ2ZDhmZDRjMWM4ZjdiM2EyZGEzNGQzY2EyODY0N2U3ODRkYTliY2E0MmNkOTE2NTA4MzM3IiwiaWF0IjoxNjc5OTkxNTg5fQ.iTA1cmseF9_LFXFVgVIUfV_Q7UzqVBkhQ60XpScuhyE`;
  const [selectedFile, setSelectedFile] = useState("");
  const { data: signer } = useSigner();
  const [showFiles, setShowFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [fileUploaded, setFileUploaded] = useState(false);
  let boxcontract;
  if (customSigner) {
    boxcontract = new ethers.Contract(newAddress, BoxAbi, customSigner);
  }
  const downloadFile = (url, fileName) => {
    fetch(url)
      .then((response) => {
        return response.blob();
      })
      .then((blob) => {
        saveAs(blob, fileName);
      });
  };

  const changeHandler = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleSubmission = async () => {
    let signerr;
    let provider;
    if (localStorage.getItem("isMagic") == "true") {
      let [magicSigner, magicProvider] = getMagic1();
      signerr = magicSigner;
      provider = magicProvider;
      console.log("Magicccccccccccccccc", magicSigner, magicProvider);
    } else {
      // const { data: signer } = useSigner();
      signerr = signer;
    }
    let boxContract = new ethers.Contract(newAddress, BoxAbi, signerr);
    setIsLoading(true);
    const formData = new FormData();

    formData.append("file", selectedFile);

    const metadata = JSON.stringify({
      name: selectedFile?.name,
    });

    formData.append("pinataMetadata", metadata);

    const options = JSON.stringify({
      cidVersion: 0,
    });
    formData.append("pinataOptions", options);

    try {
      await axios
        .post("https://api.pinata.cloud/pinning/pinFileToIPFS", formData, {
          maxBodyLength: "Infinity",
          headers: {
            "Content-Type": `multipart/form-data; boundary=${formData._boundary}`,
            Authorization: JWT,
          },
        })
        .then(async (responce) => {
          const size = responce.data.PinSize / 1024;
          const sizeKb = Math.round(size);
          const splitted = selectedFile?.name.split(".");
          const type = splitted[1];
          console.log("splitted", type);

          let eHash = await axios.post(
            `${process.env.REACT_APP_SERVER_URL}/encrypt-data`,
            {
              data:
                "https://ipfs.io/ipfs/" +
                responce?.data?.IpfsHash?.replaceAll('"', ""),
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );
          console.log("Encryteddddddddddddddddd", eHash);
          if (eHash.data.success) {
            await boxContract
              .addFile(eHash?.data?.data, sizeKb, selectedFile?.name)
              .then((tx) =>
                tx.wait().then(() => {
                  toast.success("Uploaded Successfully");
                  setIsLoading(false);
                  setFileUploaded(true);
                })
              );
          } else {
            toast.error("IPFS upload fail, Contact Admin....");
          }
          setSelectedFile("");
        });
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };
  const getFiles = async () => {
    await boxcontract.getAllFile().then(async (res) => {
      console.log("ressssssssssssssssss", res);
      let dData = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/decrypt-data`,
        {
          data: res,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      console.log("decrypted", dData);
      // if (dData.data.success) {
      // } else {
      // }
      // console.log("Get Files", res);
      setShowFiles(dData?.data?.data);
    });
  };
  useEffect(() => {
    if (customSigner) {
      getFiles();
    }
  }, [customSigner, isLoading]);

  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />
      <div className="antialiased bg-[#212445] w-full min-h-screen text-slate-300 relative py-4">
        <div className="grid grid-cols-12 mx-auto gap-2 sm:gap-4 md:gap-6 lg:gap-10 xl:gap-14 max-w-7xl my-10 px-2">
          <Profile />

          {localStorage.getItem("visiterBox") == "false" ? (
            <div className={` w-full ${isLoading ? " blur-xl " : ""}`}>
              <button
                onClick={() => navigate("/creator")}
                className=" bg-white rounded-sm px-8 py-2 mb-2 text-black font-[600]"
              >
                Back
              </button>

              <div className=" border border-slate-300 w-fit p-1 md:p-4 relative">
                <label className="form-label block text-2xl font-bold w-fit mt-4">
                  Choose File
                </label>
                <input type="file" onChange={changeHandler} />
                <button
                  onClick={handleSubmission}
                  className="text-xl ml-auto block bg-slate-100 text-black rounded-sm px-3 py-1 font-bold"
                >
                  Submit
                </button>
              </div>
            </div>
          ) : (
            <h1 className={` text-3xl text-white  `}>Files</h1>
          )}
          <div
            className={`${
              localStorage.getItem("visiterBox") == "false"
                ? " mt-52 mx-auto "
                : "mt-20 mx-auto "
            }`}
          >
            {showFiles.length > 0 ? (
              showFiles?.map((item, index) => (
                <div
                  key={index}
                  className={`md:flex md:-ml-20 justify-between gap-10 border-b-2 border-b-white w-[60vw] lg:w[50vw] py-5 
                    `}
                >
                  <h1 className="text-white md:min-w-[200px] lg:min-w-[200px]">
                    {item?.fileName.length > 20 &&
                      item?.fileName.slice(0, 20) +
                        "..." +
                        item?.fileName.slice(-6)}
                    {item?.fileName.length < 20 && item?.fileName}
                  </h1>
                  {/* <h1 className="text-white min-w-[200px] hidden xl:block ">{item?.uri}</h1> */}

                  <h1 className="text-white min-w-[100px] text-left">
                    {item?.uri?.slice(0, 7) + "..." + item?.uri?.slice(-3)}
                  </h1>

                  <h1
                    className="text-white hover:cursor-pointer min-w-[100px] "
                    onClick={() => downloadFile(item?.uri, item?.fileType)}
                  >
                    Download File
                  </h1>
                  <a href={item?.uri} target="_blank">
                    <FiExternalLink />
                  </a>
                </div>
              ))
            ) : (
              <>
                <h1 className="text-3xl w-[50vw] mt-52 text-white my-10">
                  This Box don't have any files
                </h1>
              </>
            )}
            {fileUploaded && (
              <button
                onClick={() => navigate("/creator")}
                className=" bg-white rounded-sm px-8 py-2 my-6 float-right text-black font-[600]"
              >
                done
              </button>
            )}
          </div>
        </div>
      </div>
      {localStorage.getItem("isMagic") == "false" ? (
        <div className="  px-5 text-white absolute top-2 right-8">
          <ConnectButton className="" />
        </div>
      ) : null}
      <div
        onClick={() => {
          // console.log(localStorage.getItem("token"))
          // localStorage.clear()
          // window.location.reload();
          localStorage.setItem("reload", true);
          navigate("/#");
        }}
        className="absolute bottom-4 left-4 text-white bg-black px-3 py-1 rounded-sm cursor-pointer"
      >
        Logout
      </div>
      {localStorage.getItem("isMagic") == "false" ? (
        <div className="  px-5 text-white absolute top-2 right-8">
          <ConnectButton className="" />
        </div>
      ) : (
        // <div className=" bg-white rounded-sm  px-5 text-black absolute top-2 right-8">
        //   {localStorage.getItem("walletBalance") > 0.001
        //     ? localStorage.getItem("walletBalance") + "ETH"
        //     : "Insufficient Balance"}
        // </div>
        ""
      )}
      <Loading isLoading={isLoading} />
    </>
  );
};

export default Files;
